import React, { useState, useEffect } from "react";
import { Grid, Container, Typography, makeStyles } from "@material-ui/core";
import Page from "src/components/Page";
import MyCourseCard from "./MyCourseCard";
import * as actions from "src/actions/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const MyCoursesListView = () => {
  const classes = useStyles();
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    actions
      .getMyCourses()
      .then((response) => {
        setCourses(response.data);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  }, []);

  return (
    <Page className={classes.root} title="Course Detail">
      <Container maxWidth={false}>
        <Grid>
          <Typography variant="h2">My Courses Details</Typography>
        </Grid>
        <Grid>
          {courses.map((course, index) => (
            <MyCourseCard course={course} key={index} />
          ))}
        </Grid>
      </Container>
    </Page>
  );
};

export default MyCoursesListView;
